import { render, staticRenderFns } from "./SectionExpander.vue?vue&type=template&id=07bddf12&"
import script from "./SectionExpander.vue?vue&type=script&lang=js&"
export * from "./SectionExpander.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports